module.exports = __webpack_public_path__ + "img/PP-SecrecyBrokers-Banner-1920-effets.048b9aad.jpg";